import { render, staticRenderFns } from "./golongantabungan.vue?vue&type=template&id=19e58ecc&scoped=true&"
import script from "./golongantabungan.vue?vue&type=script&lang=js&"
export * from "./golongantabungan.vue?vue&type=script&lang=js&"
import style0 from "./golongantabungan.vue?vue&type=style&index=0&id=19e58ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e58ecc",
  null
  
)

export default component.exports